import React from 'react'

import DynamicSchedulingCard from 'layouts/DynamicSchedulingCard'
import arrowSrc from './arrow.svg'

import './style.css'

export default ({ isCalendarSeat }) => (
  <div className="meetings-in-convo-preview">
    <div className="meetings-in-convo-preview-message">
      <p>Get meetings from conversations</p>
      <img className="meetings-in-convo-arrow" src={arrowSrc} alt="" />
    </div>
    <div className="meetings-in-convo-preview-container">
      <div className="meetings-in-convo-preview-content-message message-1">
        <div className="meetings-in-convo-preview-content-message-placeholder" />
        <div className="meetings-in-convo-preview-content-message-placeholder" />
      </div>
      <div className="meetings-in-convo-preview-content-message message-2">
        Sweet! Here&rsquo;s my teammate&rsquo;s calendar to book a meeting
      </div>
      <DynamicSchedulingCard
        className="meetings-in-convo-preview-content-card"
        showEmptyValues={false}
        hideName={true}
      />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/layouts/MeetingsInConvoPreview/index.js